import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import './index.css';
import * as serviceWorker from './serviceWorker';
import configureStore from './store/configureStore';
import routes from './routes/routes';


const store = configureStore();

const app = (
    <Provider store={store}>
        {/* <BrowserRouter>
            <App />
        </BrowserRouter> */}
        {routes}
    </Provider>
);

ReactDOM.render(app, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
